import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import {
  faTimes as farTimes, faBook as farBook, faSync as farSync, faShare as farShare, faSurprise as farSurprise, faCalendar as farCalendar, faSpinner as farSpinner, faPencil as farPencil, faWrench as farWrench, faCamera as farCamera, faPlus as farPlus, faEnvelope as farEnvelope, faPlusCircle as farPlusCircle, faInfoCircle as farInfoCircle, faFilter as farFilter, faTrash as farTrash, faEllipsisV as farEllipsisV, faReceipt as farReceipt, faPhone as farPhone, faMapMarkedAlt as farMapMarkedAlt, faMapMarkerAlt as farMapMarkerAlt, faHotel as farHotel, faWarehouseAlt as farWarehouseAlt, faUsersClass as farUsersClass, faBuilding as farBuilding, faCheck as farCheck, faCopy as farCopy, faTimesCircle as farTimesCircle, faCheckCircle as farCheckCircle, faEdit as farEdit, faHome as farHome, faBed as farBed, faBath as farBath, faRuler as farRuler, faRedo as farRedo,
  faNetworkWired as farNetworkWired, faDoNotEnter as farDoNotEnter, faUniversity as farUniversity, faMoneyBill as farMoneyBill,
  faTasks as farTasks, faDoorClosed as farDoorClosed, faShield as farShield, faGlobe as farGlobe, faMoneyCheck as farMoneyCheck,
  faUserCircle as farUserCircle,
  faCashRegister as farCashRegister,
  faThList as farThList,
  faChevronRight as farChevronRight,
  faEyeSlash as farEyeSlash,
  faUndo as farUndo,
  faIndent as farIndent,
  faChevronDown as farChevronDown, faChevronUp as farChevronUp, faDownload as farDownload, faFileSignature as farFileSignature,
  faChevronLeft as farChevronLeft,
  faCog as farCog,
  faUsers as farUsers,
  faExclamationTriangle as farExclamationTriangle,
  faHistory as farHistory,
  faExternalLink
} from '@fortawesome/pro-regular-svg-icons';

import {
  faRuler, faWrench, faBook, faBuilding, faTimes, faFilter, faTasks, faEnvelope, faComment, faTrash, faClipboardList, faMoneyCheckAlt, faSync, faShare, faGlass, faUserAlt, faCalendarAlt, faDollarSign, faAlarmExclamation, faReceipt, faUniversity, faChartLine, faGavel, faCashRegister, faPencilAlt, faPencil, faCheck, faEdit, faChevronUp, faChevronDown, faBan, faBalanceScale, faBriefcase, faRedo, faCalculator, faExclamationTriangle, faClipboard, faPhone, faMobile, faEnvelopeOpen, faMapMarkedAlt, faLock, faUnlock, faGlobe, faCheckCircle, faEye, faTimesCircle, faChevronRight, faUsers, faDoorClosed, faTruck, faMoneyCheck, faFileInvoice, faPaperclip, faImages, faVideo, faUserCircle, faComments, faMapMarkerAlt, faMoneyCheckEdit, faShapes, faCartPlus, faBadgeDollar, faMoneyBill, faShield, faSearch, faInfoCircle, faAppleAlt, faFileAlt, faFileInvoiceDollar, faFileSignature, faCopy, faCog, faCheckSquare, faGlasses, faMinusCircle, faArrowsAlt, faBackward, faForward, faHotel, faCircle, faHome, faShieldAlt, faPrint, faAppleCrate, faSack, faSlidersH, faClipboardListCheck, faAngleUp, faTh, faBinoculars, faSortAmountDownAlt, faSortAmountDown, faSortAlphaDown, faSortAlphaDownAlt, faCreditCard, faAngleDown, faChartPie, faFileExcel, faFileDownload, faWindowClose, faQrcode
} from '@fortawesome/pro-solid-svg-icons';

import {
  faTimes as falTimes
} from '@fortawesome/pro-light-svg-icons';

const icons: any = [
  farHistory,
  farChevronLeft,
  farExclamationTriangle,
  faClipboardListCheck,
  faRuler,
  faSlidersH,
  farUsers,
  farCog,
  farEyeSlash,
  farUndo,
  faExternalLink,
  farIndent,
  farThList,
  farChevronRight,
  farCashRegister,
  farDownload,
  farFileSignature,
  farChevronDown,
  farChevronUp,
  faHome,
  farMoneyCheck,
  farGlobe,
  farShield,
  farDoorClosed,
  farTasks,
  farMoneyBill,
  farUniversity,
  farNetworkWired,
  farDoNotEnter,
  faMoneyCheckEdit,
  farReceipt,
  farInfoCircle,
  farPlusCircle,
  farPlus,
  farCamera,
  farPencil,
  farSpinner,
  farEllipsisV,
  farTrash,
  farPhone,
  farMapMarkedAlt,
  farMapMarkerAlt,
  faAppleCrate,
  farBook,
  farSync,
  farShare,
  farCheck,
  farCopy,
  farCheckCircle,
  farTimesCircle,
  farEdit,
  farHome,

  faBook,
  faMapMarkerAlt,
  faComments,
  faEnvelopeOpen,
  faUserCircle,
  faVideo,
  farTimes,
  farFilter,
  faBuilding,
  farSurprise,
  faTimes,
  faFilter,
  faTasks,
  faEnvelope,
  faComment,
  faTrash,
  faClipboardList,
  faMoneyCheckAlt,
  faSync,
  faShare,
  faGlass,
  faUserAlt,
  faCalendarAlt,
  faDollarSign,
  faAlarmExclamation,
  faReceipt,
  faUniversity,
  faChartLine,
  faCircle,
  faGavel,
  faCashRegister,
  faSortAmountDownAlt,
  faSortAmountDown,
  faSortAlphaDown,
  faSortAlphaDownAlt,
  faCreditCard,
  faAngleDown,
  faChartPie,
  farCalendar,
  faPencilAlt,
  faPencil,
  faAngleUp,
  faWindowClose,
  faTh,
  faBinoculars,
  faCheck,
  faQrcode,
  faEdit,
  faChevronUp,
  faChevronDown,
  faBan,
  faBalanceScale,
  faWrench,
  farWrench,
  faBriefcase,
  faRedo,
  faCalculator,
  faExclamationTriangle,
  faClipboard,
  faPhone,
  faMobile,
  faMapMarkedAlt,
  farEnvelope,
  faGlobe,
  faCheckCircle,
  faLock,
  faUnlock,
  faEye,
  faTimesCircle,
  faChevronRight,
  faUsers,
  faDoorClosed,
  faTruck,
  faMoneyCheck,
  faFileInvoice,
  faArrowsAlt,
  faBackward,
  faForward,
  faPaperclip,
  faImages,
  faShapes,
  faCartPlus,
  faBadgeDollar,
  faMoneyBill,
  faShield,
  faSearch,
  faFileExcel,
  faFileDownload,
  faInfoCircle,
  faAppleAlt,
  faExclamationTriangle,
  farHotel,
  farWarehouseAlt,
  farUsersClass,
  farBuilding,
  faFileAlt,
  faFileInvoiceDollar,
  faFileSignature,
  faCopy,
  faCog,
  faCheckSquare,
  faGlasses,
  farBed,
  farBath,
  farRuler,
  faMinusCircle,
  farRedo,
  farUserCircle,
  faShieldAlt,
  faPrint,
  faSack,
  falTimes
];

@NgModule({
  imports: [
    FontAwesomeModule
  ],
  exports: [],
  providers: [],
})
export class IconProviderModule {
  constructor(iconLibrary: FaIconLibrary) {
    iconLibrary.addIcons(...icons);
  }
}
